<div ng-controller="setResponsibleController as setResponsibleCtrl" class="modal-view activity-details solo">
    <c-auto-form config="setResponsibleCtrl.autoFormConfig"></c-auto-form>
</div>